import { Hammer, PackageCheck, Send, XCircle } from "lucide-react";
import { BusyButton } from "@/components/acquisitions/BusyButton";
import type { BinderyRequestDetail } from "@/lib/api/bindery";

type HeaderAction = "send" | "cancel" | "repair" | "receive";

interface BinderyRequestActionsProps {
  status: BinderyRequestDetail["status"];
  pendingKey: string | null;
  onAction: (action: HeaderAction) => void;
}

export function BinderyRequestActions({
  status,
  pendingKey,
  onAction,
}: BinderyRequestActionsProps) {
  const locked = pendingKey !== null;
  return (
    <div className="flex flex-wrap gap-2">
      {status === "DRAFT" && (
        <>
          <BusyButton
            busy={pendingKey === "send"}
            disabled={locked}
            icon={<Send className="mr-2 h-4 w-4" />}
            onClick={() => onAction("send")}
          >
            Send to vendor
          </BusyButton>
          <BusyButton
            variant="outline"
            busy={pendingKey === "cancel"}
            disabled={locked}
            icon={<XCircle className="mr-2 h-4 w-4" />}
            onClick={() => onAction("cancel")}
          >
            Cancel
          </BusyButton>
        </>
      )}
      {status === "SENT" && (
        <BusyButton
          variant="outline"
          busy={pendingKey === "repair"}
          disabled={locked}
          icon={<Hammer className="mr-2 h-4 w-4" />}
          onClick={() => onAction("repair")}
        >
          Mark in repair
        </BusyButton>
      )}
      {(status === "SENT" || status === "IN_REPAIR") && (
        <BusyButton
          busy={pendingKey === "receive"}
          disabled={locked}
          icon={<PackageCheck className="mr-2 h-4 w-4" />}
          onClick={() => onAction("receive")}
        >
          Receive batch
        </BusyButton>
      )}
    </div>
  );
}
